export const CATALOG_ROUTES = {
    LIST: "/settings/catalogs/",
    // A brand_id of 0 addresses the brandless bucket
    BRAND_ITEMS: "/settings/catalogs/{catalog_id}/brands/{brand_id}/",
    ITEM_DETAILS: "/settings/catalogs/{catalog_id}/brands/{brand_id}/items/{item_id}/",
}
